import styled from 'styled-components';
import { WaterMark } from '../styles';

export const TableTestsSupplier = styled.table`
  th,
  td {
    padding: 0.2rem 0.4rem;
    text-align: left;
  }
`;

export const BackgroundWatermark = styled(WaterMark)`
  display: block;
  position: fixed;
  top: 80vh;
  z-index: -9;
  width: 100vw;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
`;
export const HeaderDocument = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.pantoneBlack};
  color: ${({ theme }) => theme.white};
  font-size: 1.4rem;
  font-weight: bold;
  padding: 0.4rem;
  margin: 0 0 0;
  width: 100%;
`;

const BaseLayout = styled.div`
  width: 100%;
`;

export const BodyDocument = styled(BaseLayout)`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0 0;

  table {
    width: 100%;
  }
`;
export const FooterDocument = styled(BaseLayout)`
  display: flex;
  flex-direction: column;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;

  span {
    font-size: 10px;
    opacity: 0.8;
    color: #cccccc;
    margin: 0;
    text-align: right;
  }
`;

export const ImageLogo = styled.img`
  width: 115px;
  height: 30px;
`;
interface ITitleBox {
  $title?: string;
  $maxWidth?: string;
  $gap?: string;
}

export const TitleBox = styled.div<ITitleBox>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
  gap: ${({ $gap }) => $gap || '0.6rem'};
  padding: 0 0 0.4rem;

  &:before {
    content: '${({ $title }) => $title}';
    display: block;
    width: 100%;
    font-size: 1rem;
    font-weight: bold;
    padding: 0.4rem 0.4rem;
    color: ${({ theme }) => theme.white};
    background-color: ${({ theme }) => theme.pantoneBlack};
    border-radius: 4px;
  }
`;

export const TitleRow = styled.div<ITitleBox>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 400px;
  color: ${({ theme }) => theme.pantoneBlack};
  padding: 0 0.4rem;

  :before {
    content: '${({ $title }) => $title}: ';
    display: block;
    width: fit-content;
    font-weight: bold;
    padding: 0 0.4rem 0 0;
    letter-spacing: 1px;
  }
`;

